// src/Screens/CleanupEndpoint.jsx
// This creates a hidden page that triggers cleanup when visited

import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { runStatsCleanup } from '../Services/statsCleanupJob';
import { runAllCleanupTasks } from '../Services/cleanUpExpiredGames';

const CleanupEndpoint = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('idle');
  const [result, setResult] = useState(null);
  
  useEffect(() => {
    const runCleanup = async () => {
      // Simple security check - you should use a proper secret
      const secret = searchParams.get('secret');
      if (secret !== 'your-secret-key-here') {
        setStatus('unauthorized');
        return;
      }
      
      setStatus('running');
      
      try {
        // Run both game cleanup and stats cleanup
        const gameCleanup = await runAllCleanupTasks();
        await runStatsCleanup();
        
        setResult({
          success: true,
          gameCleanup,
          timestamp: new Date().toISOString()
        });
        setStatus('success');
      } catch (error) {
        setResult({
          success: false,
          error: error.message,
          timestamp: new Date().toISOString()
        });
        setStatus('error');
      }
    };
    
    runCleanup();
  }, [searchParams]);
  
  // Return a simple response page
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-md mx-auto bg-white rounded-lg shadow p-6">
        <h1 className="text-xl font-bold mb-4">Cleanup Status</h1>
        
        <div className="space-y-2">
          <p>Status: <span className={`font-bold ${
            status === 'success' ? 'text-green-600' : 
            status === 'error' ? 'text-red-600' : 
            status === 'running' ? 'text-yellow-600' : 
            'text-gray-600'
          }`}>{status}</span></p>
          
          {result && (
            <pre className="bg-gray-100 p-3 rounded text-xs overflow-auto">
              {JSON.stringify(result, null, 2)}
            </pre>
          )}
        </div>
      </div>
    </div>
  );
};

export default CleanupEndpoint;